import React, { useState, useEffect } from "react";

function Informer(props) {
  const [showInformer, setShowInformer] = useState(
    JSON.parse(localStorage.getItem("showInformer"))
  );

  const onClickHandler = () => {
    if (JSON.parse(localStorage.getItem("showInformer")) !== false) {
      localStorage.setItem("showInformer", false);
    }
    setShowInformer(!showInformer);
  };

  useEffect(() => {
    if (localStorage.getItem("showInformer") === null) {
      localStorage.setItem("showInformer", true);
      setShowInformer(true);
    }
  }, []);
  return (
    <>
      {showInformer ? (
        <div style={{ padding: "0 9px" }} className="content-block">
          <p>
            Вы можете использовать кнопки: <b>1</b>, <b>2</b>, <b>3</b>,{" "}
            <b>4</b>, <b>5</b> для выбора ответа.
          </p>
          <p>
            Нажмите <b>пробел</b> для пропуска вопроса.
          </p>
          <div
            className="button"
            style={{
              margin: "0 auto 1.1rem auto",
              width: "auto",
              maxWidth: "110px",
            }}
            onClick={onClickHandler}
          >
            Понятно
          </div>
        </div>
      ) : (
        <div
          onClick={onClickHandler}
          style={{
            padding: "0 0.9rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
          }}
          className="content-block"
        >
          <p>Управление кнопками </p> <i className="fas fa-chevron-down"></i>
        </div>
      )}
    </>
  );
}

export default Informer;
